<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="cube icon"></i>
      {{ $t("odoo integration") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/odoo.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <div class="ui dividing small header">
            <i class="info icon"></i> {{ $t("general info") }}
          </div>
          <div class="fields">
            <div class="ten wide field">
              <label for="">{{ $t("integration name") }}</label>
              <input
                type="text"
                name="name"
                v-model="meta.setup.integration_name"
              />
            </div>
            <div class="six wide field">
              <label for="">{{ $t("odoo emitter id") }}</label>
              <input
                type="text"
                name="odoo_emitter_id"
                v-model="meta.setup.odoo_emitter_id"
              />
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("fel emitter") }}</label>
            <fel-emitter-search
              ref="fel_emitter_search"
              @select_emitter="set_emitter"
              @clear="clear_emitter"
            />
          </div>
          <div class="ui dividing small header">
            <i class="info icon"></i> {{ $t("default values") }}
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label for="">{{ $t("email") }}</label>
              <input
                type="text"
                name="default_email"
                v-model="meta.setup.default_email"
              />
            </div>
            <div class="eight wide field">
              <label for="">{{ $t("address") }}</label>
              <input
                type="text"
                name="default_address"
                v-model="meta.setup.default_address"
              />
            </div>
          </div>
          <div class="fields">
            <div class="three wide field">
              <label for="">{{ $t("zip code") }}</label>
              <input
                type="text"
                name="default_zip_code"
                v-model="meta.setup.default_zip_code"
              />
            </div>
            <div class="four wide field">
              <label for="">{{ $t("country") }}</label>
              <input
                type="text"
                name="default_country"
                v-model="meta.setup.default_country"
              />
            </div>
            <div class="four wide field">
              <label for="">{{ $t("department") }}</label>
              <input
                type="text"
                name="default_department"
                v-model="meta.setup.default_department"
              />
            </div>
            <div class="five wide field">
              <label for="">{{ $t("municipality") }}</label>
              <input
                type="text"
                name="default_municipality"
                v-model="meta.setup.default_municipality"
              />
            </div>
          </div>

          <div class="ui dividing small header">
            <i class="file alternate icon"></i> {{ $t("billing policy") }}
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label for="">{{ $t("number of invoices") }}</label>
              <input
                type="text"
                name="number_invoices"
                v-model="meta.setup.number_of_invoices"
              />
            </div>
            <div class="eight wide field">
              <label for="">{{ $t("matching nits") }}</label>
              <input
                type="text"
                name="matching_nit"
                v-model="meta.setup.matching_nit"
              />
            </div>
          </div>

          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <!-- <div
        class="ui left floated red icon right labeled button"
        v-if="meta.uuid"
        @click="remove"
      >
        <i class="trash icon"></i>
        {{ $t("delete") }}
      </div> -->
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui blue icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import FelEmitterSearch from "./FelEmitterSearch";
// import GenericContainer from "@/components/GenericContainer";

export default {
  name: "OdooIntegrationModalIndex",
  components: {
    FelEmitterSearch,
    // StaffSearch,
  },
  props: {},
  computed: {},
  data() {
    return {
      meta: {
        uuid: "",
        setup: {},
      },
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * Get emitter
       */
      if (data) {
        if (data.uuid) {
          local_api(vm, "post", "/intercable_billing/odoo_integration/do-get", {
            u: data.uuid,
          })
            .then((rIntegration) => {
              if (rIntegration) {
                vm.meta.uuid = data.uuid;
                vm.meta.setup = rIntegration.setup;
                if (rIntegration.felgt_emitter)
                  vm.$refs.fel_emitter_search.set_emitter(
                    rIntegration.felgt_emitter,
                  );
              }
            })
            .catch((err) => {
              error_toast(err);
            });
          // console.log(data);
        }
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          allowMultiple: true,
          onVisible() {
            // vm.init_dropdowns();
            // setTimeout(() => {
            //   window.jQuery(vm.$refs.admission_date_calendar).calendar({
            //     type: "date",
            //     onChange(value) {
            //       vm.admission_date = value;
            //     },
            //   });
            //   if (vm.status_id)
            //     window
            //       .jQuery(vm.$refs.status_dropdown)
            //       .dropdown("set selected", vm.status_id);
            //   if (vm.country_id)
            //     window
            //       .jQuery(vm.$refs.country_dropdown)
            //       .dropdown("set selected", vm.country_id);
            //   if (vm.area_id)
            //     window
            //       .jQuery(vm.$refs.area_dropdown)
            //       .dropdown("set selected", vm.area_id);
            //   if (vm.job_position_id)
            //     window
            //       .jQuery(vm.$refs.job_position_dropdown)
            //       .dropdown("set selected", vm.job_position_id);
            //   if (vm.team_id)
            //     window
            //       .jQuery(vm.$refs.team_dropdown)
            //       .dropdown("set selected", vm.team_id);
            //   if (vm.grouper_id)
            //     window
            //       .jQuery(vm.$refs.grouper_dropdown)
            //       .dropdown("set selected", vm.grouper_id);
            //   if (vm.immediate_superior_id)
            //     window
            //       .jQuery(vm.$refs.immediate_superior_dropdown)
            //       .dropdown("set selected", vm.immediate_superior_id);
            // }, 200);
          },
          onHidden() {
            // vm.form.form("reset");
            vm.meta.setup = {};
            vm.meta.uuid = "";
            vm.$refs.fel_emitter_search.clean();

            window.jQuery(vm.$refs.status_dropdown).dropdown("clear");
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          odoo_emitter_id: ["empty"],
          default_email: ["empty"],
          default_address: ["empty"],
          default_zip_code: ["empty"],
          default_country: ["empty"],
          default_department: ["empty"],
          default_municipality: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/intercable_billing/odoo_integration/do-save", {
          u: vm.meta.uuid,
          s: vm.meta.setup,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("saved");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    set_emitter(emitter) {
      // console.log("set emitter", emitter);
      // console.log(emitter);
      let vm = this;
      vm.meta.setup.fel_emitter_id = emitter.emitter_id;
    },
    clear_emitter() {
      let vm = this;
      vm.meta.setup.fel_emitter_id = "";
    },
  },
  mounted() {
    // let vm = this;
    // local_api(vm, "post", "/intercable_bi/admin/do-get-catalogs", {})
    //   .then((catalogs) => {
    //     if (catalogs) {
    //       vm.catalogs = catalogs;
    //     }
    //   })
    //   .catch((err) => {
    //     error_toast(err);
    //   });
  },
  watch: {},
  updated: function () {},
};
</script>
